<div>
  <h1 class="text-2xl font-semibold mb-2">Color</h1>
  <p class="text-xs text-gray-400">
    Choose the following colors and we will generate all the necessary shades. You can also edit
    them manually.
  </p>
</div>
<hr />
@for (color of colorData(); track color.path) {
  <div>
    <h2 class="text-lg font-semibold mb-2">{{ color.name }}</h2>
    <flx-input class="w-full">
      <flx-label>
        Main value
        <button
          (click)="selectColor(color.path)"
          class="p-0 focus:bg-white"
          flxButton
          variant="text"
        >
          Edit shades
        </button>
      </flx-label>
      <input
        [formField]="color.fg[MAIN_COLOR_SHADE]"
        placeholder="#"
        flxHexColorMask
        flxInput
        type="text"
      />
      <div
        [style.backgroundColor]="color.fg[MAIN_COLOR_SHADE]().controlValue()"
        class="w-3 h-3 rounded-sm border-gray-300 border"
        flxPrefix
      ></div>
    </flx-input>
  </div>
}
@if (selectedColor(); as selectedColor) {
  <ng-template
    [flxShowModal]="true"
    (backdropClick)="selectColor(null)"
  >
    <flx-colors-shades-editor
      [shades]="selectedColor.fg"
      [colorName]="selectedColor.name"
      (closeModal)="selectColor(null)"
      (saveShades)="updateShades($event, selectedColor)"
    />
  </ng-template>
}
